var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center_submit"},[_c('section',{staticClass:"section_submit center_sec"},[_c('h4',[_vm._v("1:1 문의")]),_vm._t("forms"),_vm._t("button")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }